import React from 'react';
import Heading from '../../Heading/JavaScript/Heading';
import Code from './Code';

function Contact() {
    return (
        <section className="contact">
            <Heading heading="Contact Me" />
            <div className="contact__code" data-aos="flip-up" data-aos-delay="300">
                <Code />
            </div>
        </section>
    );
}

export default Contact



// WEBPACK FOOTER //
// ./src/Components/Contact/JavaScript/Contact.js